export default __webpack_public_path__ + "static/media/footer-searchlocation-icon.65672027.svg";